module.exports = __webpack_public_path__ + "static/quartier_E-68e18811f970b4e4d9f1da7179938a66.png";